import BlockFormatPluginFactory from '../Blocks/BlockFormatPluginFactory';
import BlockMarkdownPluginFactory from '../Blocks/BlockMarkdownPluginFactory';
import { type EditorPlugin } from '../../types/aha-editor';
import QuoteNormalizationsPlugin from './QuoteNormalizationsPlugin';

export const QuoteComponentPlugin = BlockFormatPluginFactory({
  type: 'quote',
  title: 'Quote',
  tag: 'blockquote',
  exitOnBackspace: true,
  isMultiline: false,
});

export const QuoteMarkdownPlugin = BlockMarkdownPluginFactory({
  dependencies: [QuoteComponentPlugin],
  type: 'quote',
  shortcut: '>',
});

const QuotePlugin: EditorPlugin[] = [
  QuoteComponentPlugin,
  QuoteMarkdownPlugin,
  QuoteNormalizationsPlugin,
];

export default QuotePlugin;
